import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { FaCheckCircle, FaHome, FaShoppingBag } from 'react-icons/fa';
import './OrderSuccess.css'; // We'll create this for styling

const OrderSuccess = () => {
  const location = useLocation();
  const { transactionId, amount } = location.state || {};

  return (
    <div className="order-success-container">
      <div className="success-card">
        <FaCheckCircle className="success-icon" />
        <h2>Order Placed Successfully!</h2>
        
        <div className="order-details">
          <p className="transaction-id">
            Transaction ID: <span>{transactionId || 'MOCK_123456789'}</span>
          </p>
          <p className="order-amount">
            Amount Paid: <span>₹{(amount || 0).toFixed(2)}</span>
          </p>
        </div>

        <p className="success-message">
          Thank you for your purchase! Your order has been confirmed and will be processed shortly.
        </p>

        <div className="action-buttons">
          <Link to="/" className="home-button">
            <FaHome /> Back to Home
          </Link>
          <Link to="/products" className="shop-button">
            <FaShoppingBag /> Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;